module.exports = __webpack_public_path__ + "static/heading-pillar-2-cb288a191c2a43320f007422235d7872.png";